// 获取定制直播间配置信息

import $common from '@/utils/http/modules/common.request.js'
import muTypes from '@/store/mutation-types.js'
import { CUSTOM_LIVE } from '@/utils/customLive'
export default {
  methods: {
    async getCustomLive(zbId = window.zbvd.zbid) {
      try {
        const result = await $common.customConfigApi(zbId)
        if (result.code == 0) {
          this.$store.commit(
            muTypes.setCustomConfig,
            result.dataObj.customConfig
          )
          if (result.dataObj.customConfig?.customize == 'guoke') {
            this.$store.commit(muTypes.setGuokeCustomization, true)
          }
          let customLive = ''
          if (
            result.dataObj.customConfig &&
            result.dataObj.customConfig.customize.includes('guanxizhongyan')
          ) {
            customLive = CUSTOM_LIVE['guanxizhongyan']
          } else if (
            result.dataObj.customConfig &&
            result.dataObj.customConfig.customize.includes('kate')
          ) {
            customLive = CUSTOM_LIVE['kate']
          } else if (
            result.dataObj.customConfig &&
            result.dataObj.customConfig.openConfig.includes(
              'custom_lianbang_coupon'
            )
          ) {
            customLive = CUSTOM_LIVE['lianbang']
          }
          this.$store.commit(
            muTypes.zbvd,
            Object.assign(window.zbvd, { customLive }) // ZHONG_YAN or KA_TE
          )
        }
      } catch (error) {
        console.log('error,', error)
      }
    }
  }
}
